import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'scroll',
    ...theme.scrollbarStyles,
    border: 0,
    borderRadius: 0
  },
  buttonNewSound: {
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.white_100.main,
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none'
    }
  }
}))
